const spaDefaultAuthProviderState = {
  loading: true,
  isAuthenticated: false,
  userMetadata: null,
  currentUser: null,
  hasError: false
};
const middlewareDefaultAuthProviderState = {
  loading: false,
  isAuthenticated: false,
  userMetadata: null,
  currentUser: null,
  hasError: false
};
export {
  middlewareDefaultAuthProviderState,
  spaDefaultAuthProviderState
};
